var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Overflow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "346px",
    height: "197px",
    viewBox: "0 0 346 197",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "404_overflow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 57.5,
    cy: 57.5,
    r: 57.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.1%",
    y: "-4.3%",
    width: "112.2%",
    height: "112.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.031372549   0 0 0 0 0.129411765   0 0 0 0 0.258823529  0 0 0 0.24 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 404,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-547.000000, -251.000000)",
    id: "404_overflow"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(547.000000, 253.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.24,76.44 L50.24,20.92 L49.92,20.92 L12.16,76.44 L50.24,76.44 Z M63.04,76.44 L78.4,76.44 L78.4,88.44 L63.04,88.44 L63.04,115 L50.24,115 L50.24,88.44 L0.48,88.44 L0.48,75.32 L52.16,1.56 L63.04,1.56 L63.04,76.44 Z M317.12,76.44 L317.12,20.92 L316.8,20.92 L279.04,76.44 L317.12,76.44 Z M329.92,76.44 L345.28,76.44 L345.28,88.44 L329.92,88.44 L329.92,115 L317.12,115 L317.12,88.44 L267.36,88.44 L267.36,75.32 L319.04,1.56 L329.92,1.56 L329.92,76.44 Z",
    id: "4-4",
    fill: "#082142"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(117.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0801745244,57 C4.84697407,61.6666667 9.61377361,64 14.3805732,64 C19.1473727,64 23.9141722,61.6666667 28.6809718,57 C33.4477713,61.6666667 38.2145709,64 42.9813704,64 C47.74817,64 52.5149695,61.6666667 57.281769,57 C62.0485686,61.6666667 66.8153681,64 71.5821677,64 C76.3489672,64 81.1157668,61.6666667 85.8825663,57 C90.6493658,61.6666667 95.4161654,64 100.182965,64 C104.949764,64 109.716564,61.6666667 114.483364,57 L114.483364,168.52833 C114.483364,172.127473 111.565682,175.045154 107.96654,175.045154 L107.96654,175.045154 C104.367397,175.045154 101.449716,172.127473 101.449716,168.52833 L101.449716,133.219241 C101.449716,129.796312 98.6748836,127.02148 95.2519544,127.02148 L95.2519544,127.02148 C91.8290251,127.02148 89.0541927,129.796312 89.0541927,133.219241 L89.0541927,188.76149 C89.0541927,191.673526 86.6935218,194.034196 83.7814867,194.034196 L83.7814867,194.034196 C80.8694516,194.034196 78.5087807,191.673526 78.5087807,188.76149 L78.5087807,122.676113 C78.5087807,119.337992 75.8026994,116.631911 72.464579,116.631911 L72.464579,116.631911 C69.1264586,116.631911 66.4203773,119.337992 66.4203773,122.676113 L66.4203773,136.693606 C66.4203773,140.432611 63.3893149,143.463674 59.6503099,143.463674 L59.6503099,143.463674 C55.9113048,143.463674 52.8802424,140.432611 52.8802424,136.693606 L52.8802424,120.764573 C52.8802424,117.295796 50.0682437,114.483798 46.5994674,114.483798 L46.5994674,114.483798 C43.1306912,114.483798 40.3186925,117.295796 40.3186925,120.764573 L40.3186925,144.581254 C40.3186925,147.672796 37.8125029,150.178985 34.7209615,150.178985 L34.7209615,150.178985 C31.62942,150.178985 29.1232304,147.672796 29.1232304,144.581254 L29.1232304,117.793016 C29.1232304,114.135428 26.15817,111.170368 22.5005825,111.170368 L19.7347109,111.170368 C17.6046722,111.170368 15.8779346,112.897105 15.8779346,115.027144 L15.8779346,115.027144 C15.8779346,117.157183 14.151197,118.88392 12.0211583,118.88392 L11.3556643,118.88392 C8.78242431,118.88392 6.62195706,116.946393 6.34280382,114.388339 L0.0801745244,57 Z",
    id: "Path-3",
    fill: "#43C8EC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#43C8EC",
    x: 7,
    y: 123,
    width: 10,
    height: 20,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#082142",
    strokeWidth: 8,
    strokeLinejoin: "square",
    cx: 57.5,
    cy: 57.5,
    r: 53.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Overflow);
export default __webpack_public_path__ + "static/media/404-overflow.fad9a31861b0afba6f921ebb8e769688.svg";
export { ForwardRef as ReactComponent };